export default __webpack_public_path__ + "1940a3fb09617dd17fb9f9e4320a9762.png";